import { motion } from 'framer-motion'
import styled from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { H3 } from '@/@bothrs-ui/web/components/typography/Heading'
import { breakpoints } from '@/config/layout'

const StSectionTitle = styled(H3)<{ hasActivities: boolean }>`
  ${({ theme, hasActivities }) => {
    return `
        display: block;
        background-color: ${theme.Colors.Background.White};

        padding: ${theme.UI.SpacingPx.Space4} ${theme.UI.SpacingPx.Space6};
        padding-bottom: ${hasActivities ? theme.UI.SpacingPx.Space1 : theme.UI.SpacingPx.Space4};
        position: sticky;
        margin: 0 -${theme.UI.SpacingPx.Space6};
        top: 0;
        z-index: 1;

        @media ${breakpoints.s} {
          padding-bottom: ${hasActivities ? theme.UI.SpacingPx.Space1 : theme.UI.SpacingPx.Space4};
        }
    `
  }}
`

const StHeaderAction = styled.div`
  ${({ theme }) => `
    position: absolute;
    z-index: 2;
    top: 24px;
    right: 24px;
    width: max-content;
    height: ${theme.UI.SpacingPx.Space6};
    display: flex;
    gap: ${theme.UI.SpacingPx.Space4};
  `}
`

const StHeaderActionText = styled(Span)`
  ${({ theme }) => `
    align-self: center;
    padding-right: ${theme.UI.SpacingPx.Space2}
  `}
`

const StContainer = styled(FlexColumn)`
  height: 100%;
  position: relative;
  overflow: hidden;
`

const StScrollContainer = styled(FlexColumn)`
  height: 100%;
  overflow: auto;

  padding: 0 ${({ theme }) => theme.UI.SpacingPx.Space6};

  @media ${breakpoints.s} {
    ${({ theme }) => `
      padding: 0 ${theme.UI.SpacingPx.Space10};
    `}
    padding-bottom: 50%;
  }

  @media ${breakpoints.m} {
    ${({ theme }) => `
      padding: 0 ${theme.UI.SpacingPx.Space12};
    `};
  }
`

const StChipContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: calc(max(var(--safe-area-inset-bottom), 20px));
  z-index: 2;

  @media ${breakpoints.s} {
    bottom: calc(max(var(--safe-area-inset-bottom), 50px));
  }
`

const AnimatedChipContainer = motion(StChipContainer)

export { AnimatedChipContainer, StContainer, StHeaderAction, StHeaderActionText, StScrollContainer, StSectionTitle }
